import { TileWrapper } from "../../../../../app/pages/conversion/home/StyledComponents";
import { GraphLoader } from "../../../../components/Loaders/src/ExpandedTableRowLoader/ExpandedTableRowLoader";
import { FlexColumn } from "../../../../styled components/StyledFlex/src/StyledFlex";

import type { IGroupTile } from "./components/SWGroupTiles";
import { SWGroupTiles } from "./components/SWGroupTiles";
import { ConversionHomepageContainer, PageDescription, PageTitle, TilesContainer } from "./StyledComponents";

interface IConversionHomepageFroProps {
    isLoading: boolean;
    tilesProps: IGroupTile[];
    translate: (key: string, params?: FixmeType) => string;
}

export const ConversionHomepageFro = ({ isLoading, tilesProps, translate }: IConversionHomepageFroProps) => (
    <ConversionHomepageContainer>
        <FlexColumn>
            <PageTitle>{translate("conversion.homepage.title")}</PageTitle>
            <PageDescription>{translate("conversion.homepage.desc")}</PageDescription>
            {isLoading ? (
                <TilesContainer>
                    <TileWrapper>
                        <GraphLoader
                            height={294}
                            width={"100%"}
                        />
                    </TileWrapper>
                    ,
                    <TileWrapper>
                        <GraphLoader
                            height={294}
                            width={"100%"}
                        />
                    </TileWrapper>
                    ,
                    <TileWrapper>
                        <GraphLoader
                            height={294}
                            width={"100%"}
                        />
                    </TileWrapper>
                </TilesContainer>
            ) : (
                <SWGroupTiles tilesProps={tilesProps} />
            )}
        </FlexColumn>
    </ConversionHomepageContainer>
);
